import React, { createContext, useContext, useState } from "react";

const DealerContext = createContext();

export const DealerProvider = ({ children }) => {
  const [dealerDetails, setDealerDetails] = useState({
    id: null,
    name: "",
    username: "",
    email: "",
    contactNumber: "",
    address: "",
    companyName: "",
    password: "", // Not recommended to store in state
  });

  // Update only specific fields without overwriting the whole object
  const updateDealerDetails = (updatedFields) => {
    setDealerDetails((prevDetails) => ({
      ...prevDetails,
      ...updatedFields,
    }));
  };

  // Reset password logic (avoid storing passwords in state directly)
  const resetPassword = (currentPassword, newPassword) => {
    if (dealerDetails.password === currentPassword) {
      updateDealerDetails({ password: newPassword });
      return true;
    }
    return false;
  };

  return (
    <DealerContext.Provider value={{ dealerDetails, updateDealerDetails, resetPassword }}>
      {children}
    </DealerContext.Provider>
  );
};

// Custom hook to access DealerAdmin context
export const DealerAdmin = () => useContext(DealerContext);
